import Env from '../config/envConfig'

import {
  AutorisationROApi as AutorisationROApiClass,
  SubsidiaryRESTServiceApi as SubsidiaryRESTServiceApiClass,
  HelpROApi as HelpROApiClass,
  EditorHelpRESTServiceApi as EditorHelpRESTServiceApiClass,
  SmPublishConnectApi as SmPublishConnectApiClass,
  SmPublishAuthApi as SmPublishAuthApiClass,
  SocialmediaUserApi as SocialmediaUserApiClass,
  SocialmediaEditorApi as SocialmediaEditorApiClass,
  UserLoginRESTServiceApi as UserLoginRESTServiceApiClass,
  ImprintApi as ImprintApiClass,
  UserHasPageApi as UserHasPageApiClass,
  UserQuizRestServiceApi as UserQuizRestServiceApiClass,
  UserSearchApi as UserSearchApiClass,
  AnnouncementApi as AnnouncementApiClass,
  Configuration,
} from '@professocialApi/professocial-core-frontend-api'
import customFetchApi from './customFetchApi'

import { FileScannerApi as FileScannerApiClass } from './filescanner/FileScannerApi'

import {
  FacebookPageApi as FacebookPageApiClass,
  FacebookPostApi as FacebookPostApiClass,
  InstagramPageApi as InstagramPageApiClass,
  LinkedInPageApi as LinkedInPageApiClass,
  InstagramPostApi as InstagramPostApiClass,
  GooglePageApi as GooglePageApiClass,
  GooglePostApi as GooglePostApiClass,
  CalendarApi as CalendarApiClass,
  PostTemplateApi as PostTemplateApiClass,
  AboTopicsApi as AboTopicsApiClass,
  FacebookConnectApi as FacebookConnectApiClass,
  InstagramConnectApi as InstagramConnectApiClass,
  Configuration as SMConfiguration,
  PageSettingsApi as PageSettingsApiClass,
  AboSettingsApi as AboSettingsApiClass,
  PostApi as PostApiClass,
  DeferredPostApi as DeferredPostApiClass,
  MediaFileApi as MediaFileApiClass,
  UrlInformationExtractorApi as UrlInformationExtractorApiClass,
} from '@3m5/sm_publish-frontend-api'
import smModuleFetchApi from '../api/smModuleFetchApi'
import customMultipartFetchApi from './customMultipartFetchApi'

const BASE_PATH_API = Env.restBase

export const SmPublishConnectApi = new SmPublishConnectApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const UserQuizRestServiceApi = new UserQuizRestServiceApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const UserSearchApi = new UserSearchApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const AnnouncementApi = new AnnouncementApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const AutorisationROApi = new AutorisationROApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const SubsidiaryRESTServiceApi = new SubsidiaryRESTServiceApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const HelpROApi = new HelpROApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const EditorHelpRESTServiceApi = new EditorHelpRESTServiceApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const SocialmediaUserApi = new SocialmediaUserApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const SocialmediaEditorApi = new SocialmediaEditorApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const SmPublishAuthApi = new SmPublishAuthApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const UserLoginRESTServiceAPI = new UserLoginRESTServiceApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const ImprintAPI = new ImprintApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const UserHasPageApi = new UserHasPageApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const FacebookPageApi = new FacebookPageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const InstagramPageApi = new InstagramPageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const LinkedInPageApi = new LinkedInPageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const CalendarApi = new CalendarApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const PostTemplateApi = new PostTemplateApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const AboTopicsApi = new AboTopicsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const PostApi = new PostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const FacebookConnectApi = new FacebookConnectApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const InstagramConnectApi = new InstagramConnectApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const PageSettingsApi = new PageSettingsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const AboSettingsApi = new AboSettingsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const FacebookPostApi = new FacebookPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const InstagramPostApi = new InstagramPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const GooglePostApi = new GooglePostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const GooglePageApi = new GooglePageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const DeferredPostApi = new DeferredPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const MediaFileApi = new MediaFileApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const FileScannerApi = new FileScannerApiClass({
  basePath: BASE_PATH_API,
  fetchApi: customMultipartFetchApi(fetch),
})

export const UrlInformationExtractorApi = new UrlInformationExtractorApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))
